import "./Right.css";
export default function Right(){
    return(
        <>
        <div className="Right">
            <div>
                <a href="mailto:kaubis368@gmail.com">kaubis368@gmail.com</a>
            </div>
        </div>
        </>
    );
}